import { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import { components } from "react-select";
import { Select } from "react-select-virtualized";

interface ISelectInputVirtualize
  extends DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  field?: any;
  options: any;
  isDisabled?: boolean;
  className?: string;
  label?: string;
  validation?: any;
  onChange?: any;
  value?: any;
  isClearable?: boolean;
  defaultValue?: any;
  isLoading?: boolean;
  labelClassName?: string;
  selectClass?: string;
  placeHolder?: string;
}
const SelectInputVirtualize: React.FC<ISelectInputVirtualize> = ({
  field,
  options,
  className,
  label,
  onChange,
  value,
  defaultValue,
  isLoading,
  isClearable = true,
  isDisabled = false,
  required = false,
  placeHolder,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: isDisabled ? "#FAFAFA" : "#ffffff",
      borderColor: "#edebeb",
      minHeight: "28px",
      height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      active: "",
      //  padding: "3px",
      color: state.isSelected ? "white" : "black",
      fontSize: "12px",
    }),
    menu: (provided, state) => ({
      ...provided,
      overflowX: "auto",
      //padding: "0px 6px",
      minHeight: "auto",
      maxHeight: "auto",
      zIndex: "10px",
      fontSize: "11px",
      //whiteSpace: "normal",
      lineHeight: "100px",
    }),
    // placeholder: (provided, state) => ({
    //   ...provided,
    //   overflowX: "auto",
    //   marginLeft: "0px ",
    //   marginRight: "-3px",
    // }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "26px",
      // padding: "0px 6px",
      fontSize: "12px",
    }),

    input: (provided, state) => ({
      ...provided,
      // margin: "0px",
      fontSize: "12px",
    }),
    // indicatorSeparator: (state) => ({
    //   display: "none",
    // }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      margin: "0px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const areOptionsAvailable = Array.isArray(options) && options?.length > 0;

  return (
    <div className="w-full">
      {areOptionsAvailable ? (
        <Select
          {...field}
          className={`basic-multi-select ${className} ${
            isDisabled && "opacity-50"
          }`}
          components={components}
          menuPortalTarget={document.body}
          styles={customStyles}
          isLoading={isLoading}
          options={options}
          onChange={onChange}
          isSearchable
          isDisabled={isDisabled}
          isClearable={isClearable}
          defaultValue={defaultValue}
          value={value}
          isMulti={false}
          tabSelectsValue={false}
          placeholder={placeHolder}
        />
      ) : (
        <div>Loading ...</div>
        // You can also show a loading spinner or any other placeholder here
      )}
    </div>
  );
};

export default SelectInputVirtualize;
